/**
 * Country SEO i18n — Wave 12
 * Fills remaining language gaps for: China, India, Philippines, Saudi Arabia,
 * Nigeria, Brazil, Poland, France, and adds new countries: Belarus, Kazakhstan, Cyprus
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE12: CountrySEOMap = {

  china: {
    pl: {
      title: 'Call Center Chiny | Outsourcing Obsługi Klienta | Call IT Dev',
      description: 'Call center dla Chin: agenci mandaryńskojęzyczni, 24/7, od 3 $/h. 70% oszczędności vs Szanghaj.',
      heroTitle: 'Call Center dla Chin — Mandaryński Support',
      heroSubtitle: 'Obsługa klienta po mandaryńsku w cenach nearshore. 70% taniej niż Szanghaj.',
    },
    nl: {
      title: 'Callcenter China | Klantenservice Outsourcing | Call IT Dev',
      description: 'Callcenter voor China: Mandarijnsprekende agenten, 24/7, vanaf 3 $/u. 70% besparing vs Shanghai.',
      heroTitle: 'Callcenter voor China — Mandarijns Support',
      heroSubtitle: 'Premium klantenservice in het Mandarijn tegen nearshore-prijzen.',
    },
    it: {
      title: 'Call Center Cina | Assistenza Clienti in Mandarino | Call IT Dev',
      description: 'Call center per la Cina: agenti madrelingua mandarino, 24/7, da 3 $/h. 70% risparmio vs Shanghai.',
      heroTitle: 'Call Center per la Cina — Supporto in Mandarino',
      heroSubtitle: 'Assistenza clienti premium in mandarino a prezzi nearshore.',
    },
    pt: {
      title: 'Call Center China | Atendimento ao Cliente em Mandarim | Call IT Dev',
      description: 'Call center para China: agentes mandarim nativos, 24/7, a partir de 3 $/h. 70% economia vs Xangai.',
      heroTitle: 'Call Center para China — Suporte em Mandarim',
      heroSubtitle: 'Atendimento premium em mandarim a preços nearshore.',
    },
    tr: {
      title: 'Çin Çağrı Merkezi | Mandarin Müşteri Hizmetleri | Call IT Dev',
      description: 'Çin için çağrı merkezi: Mandarin konuşan temsilciler, 24/7, 3 $/saatten başlayan fiyatlar.',
      heroTitle: 'Çin İçin Çağrı Merkezi — Mandarin Destek',
      heroSubtitle: 'Nearshore fiyatlarla premium Mandarin müşteri hizmetleri.',
    },
    ru: {
      title: 'Колл-центр Китай | Обслуживание клиентов на мандаринском | Call IT Dev',
      description: 'Колл-центр для Китая: агенты-носители мандаринского, 24/7, от 3 $/ч. 70% экономия vs Шанхай.',
      heroTitle: 'Колл-центр для Китая — Поддержка на мандаринском',
      heroSubtitle: 'Премиум-обслуживание на мандаринском по nearshore-ценам.',
    },
  },

  india: {
    zh: {
      title: '印度呼叫中心 | 英语客服外包 24/7 | Call IT Dev',
      description: '印度呼叫中心外包：英语母语座席，IST时区，CSAT 95%，3美元/小时起。',
      heroTitle: '印度呼叫中心 — 英语母语支持',
      heroSubtitle: '以nearshore价格提供优质英语客户服务。',
    },
    ja: {
      title: 'インドコールセンター | 英語カスタマーサポート | Call IT Dev',
      description: 'インド向けコールセンター：英語ネイティブ、IST時間帯、CSAT 95%、3$/時間〜。',
      heroTitle: 'インド向けコールセンター — 英語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアム英語顧客体験を。',
    },
    ko: {
      title: '인도 콜센터 | 영어 고객 서비스 아웃소싱 | Call IT Dev',
      description: '인도 콜센터 아웃소싱: 영어 원어민 상담원, IST 시간대, CSAT 95%, 시간당 3달러부터.',
      heroTitle: '인도 콜센터 — 영어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 영어 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Indien | Engelskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Indien: engelsktalande agenter, IST-tidszon, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Indien — Engelskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på engelska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Indien | Engelsksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Indien: engelsktalende agenter, IST-tidszone, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter til Indien — Engelsksproget Support',
      heroSubtitle: 'Premium kundeservice på engelsk til nearshore-priser.',
    },
    pl: {
      title: 'Call Center Indie | Outsourcing Obsługi Klienta | Call IT Dev',
      description: 'Call center dla Indii: agenci anglojęzyczni, strefa IST, CSAT 95%, od 3 $/h.',
      heroTitle: 'Call Center dla Indii — Anglojęzyczny Support',
      heroSubtitle: 'Premiumowa obsługa klienta po angielsku w cenach nearshore.',
    },
    nl: {
      title: 'Callcenter India | Engelstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor India: Engelstalige agenten, IST-tijdzone, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor India — Engelstalig Support',
      heroSubtitle: 'Premium klantenservice in het Engels tegen nearshore-prijzen.',
    },
    it: {
      title: 'Call Center India | Assistenza Clienti in Inglese | Call IT Dev',
      description: 'Call center per l\'India: agenti anglofoni, fuso IST, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per l\'India — Supporto in Inglese',
      heroSubtitle: 'Assistenza clienti premium in inglese a prezzi nearshore.',
    },
  },

  philippines: {
    zh: {
      title: '菲律宾呼叫中心 | 英语客服外包 | Call IT Dev',
      description: '菲律宾呼叫中心外包：英语母语座席，PHT时区，CSAT 95%，2.5美元/小时起。',
      heroTitle: '菲律宾呼叫中心 — 英语母语支持',
      heroSubtitle: '以极低价格提供优质英语客户服务。',
    },
    ja: {
      title: 'フィリピンコールセンター | 英語カスタマーサポート | Call IT Dev',
      description: 'フィリピンコールセンター：英語ネイティブ、PHT時間帯、2.5$/時間〜。75%コスト削減。',
      heroTitle: 'フィリピンコールセンター — 英語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアム英語顧客体験。75%コスト削減。',
    },
    ko: {
      title: '필리핀 콜센터 | 영어 고객 서비스 아웃소싱 | Call IT Dev',
      description: '필리핀 콜센터: 영어 원어민, PHT 시간대, 시간당 2.5달러부터. 75% 절감.',
      heroTitle: '필리핀 콜센터 — 영어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 영어 고객 경험. 75% 비용 절감.',
    },
    sv: {
      title: 'Callcenter Filippinerna | Kundtjänst Outsourcing | Call IT Dev',
      description: 'Callcenter för Filippinerna: engelsktalande agenter, PHT-tidszon, från 2.5 $/h. 75% besparing.',
      heroTitle: 'Callcenter för Filippinerna — Engelskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på engelska till nearshore-priser. 75% besparing.',
    },
    da: {
      title: 'Callcenter Filippinerne | Kundeservice Outsourcing | Call IT Dev',
      description: 'Callcenter til Filippinerne: engelsktalende agenter, PHT-tidszone, fra 2.5 $/t. 75% besparelse.',
      heroTitle: 'Callcenter til Filippinerne — Engelsksproget Support',
      heroSubtitle: 'Premium kundeservice på engelsk til nearshore-priser. 75% besparelse.',
    },
  },

  saudiArabia: {
    zh: {
      title: '沙特阿拉伯呼叫中心 | 阿拉伯语客服外包 | Call IT Dev',
      description: '沙特呼叫中心：阿拉伯语母语座席，AST时区，CSAT 95%，从3美元/小时起。',
      heroTitle: '沙特阿拉伯呼叫中心 — 阿拉伯语母语支持',
      heroSubtitle: '以nearshore价格为沙特市场提供优质阿拉伯语客户服务。',
    },
    ja: {
      title: 'サウジアラビアコールセンター | アラビア語カスタマーサポート | Call IT Dev',
      description: 'サウジ向けコールセンター：アラビア語ネイティブ、AST時間帯、3$/時間〜。',
      heroTitle: 'サウジアラビアコールセンター — アラビア語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムアラビア語顧客体験。',
    },
    ko: {
      title: '사우디아라비아 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '사우디 콜센터: 아랍어 원어민, AST 시간대, 시간당 3달러부터.',
      heroTitle: '사우디아라비아 콜센터 — 아랍어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 아랍어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Saudiarabien | Arabiskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Saudiarabien: arabisktalande agenter, AST-tidszon, från 3 $/h.',
      heroTitle: 'Callcenter för Saudiarabien — Arabiskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på arabiska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Saudi-Arabien | Arabisksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Saudi-Arabien: arabisktalende agenter, AST-tidszone, fra 3 $/t.',
      heroTitle: 'Callcenter til Saudi-Arabien — Arabisksproget Support',
      heroSubtitle: 'Premium kundeservice på arabisk til nearshore-priser.',
    },
  },

  brazil: {
    zh: {
      title: '巴西呼叫中心 | 葡萄牙语客服外包 | Call IT Dev',
      description: '巴西呼叫中心：葡萄牙语母语座席，BRT时区，CSAT 95%，从3美元/小时起。',
      heroTitle: '巴西呼叫中心 — 葡萄牙语母语支持',
      heroSubtitle: '以nearshore价格提供优质葡萄牙语客户服务。',
    },
    ja: {
      title: 'ブラジルコールセンター | ポルトガル語カスタマーサポート | Call IT Dev',
      description: 'ブラジル向けコールセンター：ポルトガル語ネイティブ、BRT時間帯、3$/時間〜。',
      heroTitle: 'ブラジルコールセンター — ポルトガル語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムポルトガル語顧客体験。',
    },
    ko: {
      title: '브라질 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '브라질 콜센터: 포르투갈어 원어민, BRT 시간대, 시간당 3달러부터.',
      heroTitle: '브라질 콜센터 — 포르투갈어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 포르투갈어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Brasilien | Portugisiskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Brasilien: portugisisktalande agenter, BRT-tidszon, från 3 $/h.',
      heroTitle: 'Callcenter för Brasilien — Portugisiskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på portugisiska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Brasilien | Portugisisksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Brasilien: portugisisktalende agenter, BRT-tidszone, fra 3 $/t.',
      heroTitle: 'Callcenter til Brasilien — Portugisisksproget Support',
      heroSubtitle: 'Premium kundeservice på portugisisk til nearshore-priser.',
    },
    ru: {
      title: 'Колл-центр Бразилия | Обслуживание на португальском | Call IT Dev',
      description: 'Колл-центр для Бразилии: португалоговорящие агенты, BRT, от 3 $/ч.',
      heroTitle: 'Колл-центр для Бразилии — Поддержка на португальском',
      heroSubtitle: 'Премиум-обслуживание на португальском по nearshore-ценам.',
    },
  },

  poland: {
    zh: {
      title: '波兰呼叫中心 | 波兰语客服外包 | Call IT Dev',
      description: '波兰呼叫中心：波兰语母语座席，CET时区，从5美元/小时起。',
      heroTitle: '波兰呼叫中心 — 波兰语母语支持',
      heroSubtitle: '以nearshore价格提供优质波兰语客户服务。',
    },
    ja: {
      title: 'ポーランドコールセンター | ポーランド語カスタマーサポート | Call IT Dev',
      description: 'ポーランド向けコールセンター：ポーランド語ネイティブ、CET時間帯、5$/時間〜。',
      heroTitle: 'ポーランドコールセンター — ポーランド語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムポーランド語顧客体験。',
    },
    ko: {
      title: '폴란드 콜센터 | 폴란드어 고객 서비스 | Call IT Dev',
      description: '폴란드 콜센터: 폴란드어 원어민, CET 시간대, 시간당 5달러부터.',
      heroTitle: '폴란드 콜센터 — 폴란드어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 폴란드어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Polen | Polskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Polen: polsktalande agenter, CET-tidszon, från 5 $/h.',
      heroTitle: 'Callcenter för Polen — Polskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på polska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Polen | Polsksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Polen: polsktalende agenter, CET-tidszone, fra 5 $/t.',
      heroTitle: 'Callcenter til Polen — Polsksproget Support',
      heroSubtitle: 'Premium kundeservice på polsk til nearshore-priser.',
    },
  },

  cyprus: {
    en: {
      title: 'Call Center Cyprus | Multilingual Customer Service | Call IT Dev',
      description: 'Call center for Cyprus: Greek & English-speaking agents, EET timezone, CSAT 95%, from $5/hr. 60% savings.',
      heroTitle: 'Call Center for Cyprus — Multilingual Support',
      heroSubtitle: 'Premium customer service for the Cyprus market at nearshore prices.',
    },
    fr: {
      title: 'Centre d\'appel Chypre | Service Client Multilingue | Call IT Dev',
      description: 'Centre d\'appel pour Chypre : agents grécophones et anglophones, fuseau EET, dès 5 $/h.',
      heroTitle: 'Centre d\'appel pour Chypre — Support multilingue',
      heroSubtitle: 'Service client premium pour le marché chypriote à prix nearshore.',
    },
    de: {
      title: 'Call Center Zypern | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Zypern: griechisch- und englischsprachige Agenten, EET-Zeitzone, ab 5 $/h.',
      heroTitle: 'Call Center für Zypern — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den zypriotischen Markt.',
    },
    ar: {
      title: 'مركز اتصال قبرص | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لقبرص: وكلاء ناطقون باليونانية والإنجليزية، منطقة EET، من 5 $/ساعة.',
      heroTitle: 'مركز اتصال لقبرص — دعم متعدد اللغات',
      heroSubtitle: 'خدمة عملاء متميزة للسوق القبرصي بأسعار nearshore.',
    },
    tr: {
      title: 'Kıbrıs Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Kıbrıs için çağrı merkezi: Yunanca ve İngilizce konuşan temsilciler, EET saat dilimi, 5 $/saatten.',
      heroTitle: 'Kıbrıs İçin Çağrı Merkezi — Çok Dilli Destek',
      heroSubtitle: 'Nearshore fiyatlarla Kıbrıs pazarı için premium müşteri hizmetleri.',
    },
  },

  belarus: {
    en: {
      title: 'Call Center Belarus | Russian-Speaking Customer Service | Call IT Dev',
      description: 'Call center for Belarus: Russian-speaking agents, MSK timezone, CSAT 95%, from $4/hr. 75% savings.',
      heroTitle: 'Call Center for Belarus — Russian-Speaking Support',
      heroSubtitle: 'Premium customer service in Russian for the Belarusian market.',
    },
    fr: {
      title: 'Centre d\'appel Biélorussie | Service Client Russophone | Call IT Dev',
      description: 'Centre d\'appel pour la Biélorussie : agents russophones, fuseau MSK, dès 4 $/h. 75% d\'économies.',
      heroTitle: 'Centre d\'appel pour la Biélorussie — Support russophone',
      heroSubtitle: 'Service client premium en russe pour le marché biélorusse.',
    },
    de: {
      title: 'Call Center Belarus | Russischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Belarus: russischsprachige Agenten, MSK-Zeitzone, ab 4 $/h. 75% Ersparnis.',
      heroTitle: 'Call Center für Belarus — Russischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Russisch für den belarussischen Markt.',
    },
    ru: {
      title: 'Колл-центр Беларусь | Русскоязычное обслуживание | Call IT Dev',
      description: 'Колл-центр для Беларуси: русскоговорящие агенты, часовой пояс MSK, от 4 $/ч. 75% экономия.',
      heroTitle: 'Колл-центр для Беларуси — Русскоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание клиентов на русском для белорусского рынка.',
    },
    pl: {
      title: 'Call Center Białoruś | Rosyjskojęzyczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Białorusi: rosyjskojęzyczni agenci, strefa MSK, od 4 $/h. 75% oszczędności.',
      heroTitle: 'Call Center dla Białorusi — Rosyjskojęzyczny Support',
      heroSubtitle: 'Premiumowa obsługa klienta po rosyjsku dla rynku białoruskiego.',
    },
  },

  kazakhstan: {
    en: {
      title: 'Call Center Kazakhstan | Russian & Kazakh Customer Service | Call IT Dev',
      description: 'Call center for Kazakhstan: bilingual Russian/Kazakh agents, GMT+6, CSAT 95%, from $4/hr.',
      heroTitle: 'Call Center for Kazakhstan — Bilingual Support',
      heroSubtitle: 'Premium customer service in Russian and Kazakh for the Central Asian market.',
    },
    fr: {
      title: 'Centre d\'appel Kazakhstan | Service Client Bilingue | Call IT Dev',
      description: 'Centre d\'appel pour le Kazakhstan : agents bilingues russe/kazakh, GMT+6, dès 4 $/h.',
      heroTitle: 'Centre d\'appel pour le Kazakhstan — Support bilingue',
      heroSubtitle: 'Service client premium en russe et kazakh pour le marché centrasiatique.',
    },
    ru: {
      title: 'Колл-центр Казахстан | Обслуживание на русском и казахском | Call IT Dev',
      description: 'Колл-центр для Казахстана: двуязычные агенты, GMT+6, CSAT 95%, от 4 $/ч.',
      heroTitle: 'Колл-центр для Казахстана — Двуязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на русском и казахском для центральноазиатского рынка.',
    },
    zh: {
      title: '哈萨克斯坦呼叫中心 | 俄语/哈萨克语客服 | Call IT Dev',
      description: '哈萨克斯坦呼叫中心：俄语/哈萨克语双语座席，GMT+6，从4美元/小时起。',
      heroTitle: '哈萨克斯坦呼叫中心 — 双语支持',
      heroSubtitle: '以nearshore价格为中亚市场提供双语客户服务。',
    },
    tr: {
      title: 'Kazakistan Çağrı Merkezi | Rusça ve Kazakça Destek | Call IT Dev',
      description: 'Kazakistan için çağrı merkezi: Rusça/Kazakça iki dilli temsilciler, GMT+6, 4 $/saatten.',
      heroTitle: 'Kazakistan İçin Çağrı Merkezi — İki Dilli Destek',
      heroSubtitle: 'Orta Asya pazarı için premium iki dilli müşteri hizmetleri.',
    },
  },
};
